export default __webpack_public_path__ + "static/media/elec-4.e95741a9.png";